import { render, staticRenderFns } from "./ModalProcedureExistante.vue?vue&type=template&id=cd0230d4&scoped=true"
import script from "./ModalProcedureExistante.vue?vue&type=script&lang=js"
export * from "./ModalProcedureExistante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0230d4",
  null
  
)

export default component.exports